import React from "react";
import HoneyAmla from "../../assets/images/collection/amla-candy.jpg";
import StawberryJam from "../../assets/images/collection/strawberry-jam.jpg";
import OrangeJam from "../../assets/images/collection/orange-jam.jpg";
import HoneySoap from "../../assets/images/collection/soap-honey-comb-arrangement.jpg";
import HoneyShampoo from "../../assets/images/collection/6613153.jpg";
import HoneyDryfruits from "../../assets/images/collection/honey-dryfruit.jpg";
import HoneyCinamon from "../../assets/images/collection/cinamon-honey.jpg";
import NaturalHoney from "../../assets/images/collection/natural-honey.jpg";
import HoneyFaceWash from "../../assets/images/collection/honey-face-wash.jpg";
import { Row, Col } from "react-bootstrap";
import ImageContainer from "../../components/ImageContainer/ImageContainer";


const BrandsCategory = () => {
  const collections = [
    {
      img: NaturalHoney,
      collectionName: "Natural Honey ",
    },
    {
      img: HoneyAmla,
      collectionName: "Honey Amla Candy",
    },
    {
      img: StawberryJam,
      collectionName: "Honey Strawberry Jam",
    },
    {
      img: OrangeJam,
      collectionName: "Honey Orange Jam",
    },
    {
      img: HoneySoap,
      collectionName: "Honey Soap",
    },
    {
      img: HoneyShampoo,
      collectionName: "Honey Shampoo",
    },
    {
      img: HoneyDryfruits,
      collectionName: "Honey Dryfruits",
    },
    {
      img: HoneyCinamon,
      collectionName: "Cinamon Honey ",
    },
    {
      img: HoneyFaceWash,
      collectionName: "Honey Face Wash",
    },
  ];
  return (
    <div className="container product-img subSectionWrapper px-0 pt-4 pb-0">
    
      <Row className="justify-content-center">
        {collections.map((e,index) => (
          <Col md={4} lg={2} sm={6} xs= {6} key={index}>
            {/* <div className="image-container image-container-collections mb-4">
              <img className="" src={e.img} alt="Investment asset" />
            </div>
            <h3 className="text-center image-caption mt-0  mb-4 text-decoration-none">
              {e.collectionName}
            </h3> */}
             <ImageContainer title={e.collectionName} src={e.img}/>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default BrandsCategory;
